import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import { HeaderSectionStructure } from '../../../components/header-section/header-section-types';

export const FILTER_DESCRIPTION_WITH_WATER_ANALYSIS =
  'Спроектируем и\u00A0установим комплексную систему водоочистки для загородного дома любой сложности под ключ. Анализируем воду, подбираем и\u00A0монтируем оборудование, а\u00A0также берём на\u00A0себя сервисное обслуживание. Очищаем воду от\u00A0неприятных запахов, железа, марганца, солей и\u00A0других примесей. Оформите заявку, а\u00A0мы\u00A0подберём решение, составим проект и\u00A0установим оборудование у\u00A0вас дома.';
export const FILTER_DESCRIPTION_WITHOUT_WATER_ANALYSIS =
  'Спроектируем и\u00A0установим комплексную систему водоочистки для загородного дома любой сложности под ключ. Подбираем и\u00A0монтируем оборудование, а\u00A0также берём на\u00A0себя сервисное обслуживание. Очищаем воду от\u00A0неприятных запахов, железа, марганца, солей и\u00A0других примесей. Оформите заявку, а\u00A0мы\u00A0подберём решение, составим проект и\u00A0установим оборудование у\u00A0вас дома.';

export const FILTER_HEADER_SECTION_CONFIG: HeaderSectionStructure = {
  title: 'Проектирование систем водоочистки и\u00A0монтаж фильтров очистки воды частного дома',
  description: '',
  img: {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/filter.jpg/filter.jpg`,
    alt: 'Системы фильтрации воды для загородного дома',
  },
  consultationSignupBtn: {
    elementBlock: 'landingSistemyFiltracii',
    label: 'Записаться на консультацию',
    elementText: 'Проектирование систем водоочистки и монтаж фильтров очистки воды частного дома',
  },
};
